module.exports = __webpack_public_path__ + "img/logo.d0b4141c.png";